<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-two">
<h1>Chapter Two</h1>
<p>When Anya came to class the following day, she looked at Peter curiously. He got up and went over to sit down beside her.</p>
<p>“Hi, Anya.”</p>
<p>“Hi.” She acted cautious.</p>
<p>“Are you okay with this?” Reading her mood was tough for him.</p>
<p>“My roommate said you called last night.”</p>
<p>“I did. I knew you wouldn’t be home, but I wanted to stir the pot.”</p>
<p>“What? I don’t understand.”</p>
<p>“It’s a figure of speech for stirring her up. If she’s going to act mean toward you, there will be a price to pay.”</p>
<p>“I don’t want to have trouble.”</p>
<p>“No trouble, just giving her something to think about. Did she act differently?”</p>
<p>“She asked me about you.”</p>
<p>“See, that’s a good thing. What did you say?”</p>
<p>“I told her you’re a classmate.”</p>
<p>“Oh.” He frowned.</p>
<p>“This makes you unhappy?”</p>
<p>“Well, I’m not unhappy. I guess I’m thinking about being more…with you.”</p>
<p>“More?”</p>
<p>“Maybe you’ll describe me differently if we have a date. How about coming with me to the football game on Saturday?”</p>
<p>“I don’t know football.”</p>
<p>In spite of her look of concern, he pressed ahead anyway. “That’s an excellent reason to come with me—to learn about the game.”</p>
<p>“I don’t know.”</p>
<p>Peter tried to interpret the uncertain look on her face, without success. It could mean many different things. “You came to America to get an education. This is a part of an American education.”</p>
<p>“I do not think that’s true, but…”</p>
<p>“Good, I’ll come by your dorm and get you in the morning. The game starts at noon. Wear a school sweatshirt.”</p>
<p>“I don’t have a school sweatshirt.”</p>
<p>“What? Everybody wears their school colors.”</p>
<p>Anya’s face reddened.</p>
<p>“I’m sorry. I didn’t mean to embarrass you. Is there a reason you don’t want to wear school clothes?”</p>
<p>“I have no money for such things.”</p>
<p>“I didn’t think about that. I apologize again, Anya. Will you allow me to buy a couple of things for you?”</p>
<p>“No, I can’t accept…”</p>
<p>“Listen, Anya, it’s not a big thing. I told you my folks are pretty flush with money. They built up a big college fund for me, but when I got scholarships, most of that money was left just sitting there. I want to do this for you, please?”</p>
<p>“It doesn’t seem right, Peter. I don’t want charity.” She eyed him and his determined look.</p>
<p>“Don’t look at it that way because this isn’t charity. Bringing you up to speed with the other girls at this school is, well, I don’t have the word. In the meantime, walk with me later to the bookstore and let’s do this thing?”</p>
<p>She gave him a meek smile.</p>
<p>“I’ll meet you after class this afternoon and we’ll go shopping,” he continued.</p>
<br/><p style="text-align:center;">#</p><br/>
<p>Later, going into the crowded bookstore, he led Anya to the apparel section. She looked around in awe at the huge array of clothing.</p>
<p>“Does anything stand out to you?”</p>
<p>“Will you pick for me? There’s just so much here, I can’t choose.”</p>
<p>“Okay, I’ll make clothing choices, but you can’t complain.”</p>
<p>Anya chuckled.</p>
<p>Peter opted for more than just a sweatshirt. He selected a skirt, blouse, and also a sweater.</p>
<p>“This is too much.”</p>
<p>“No, it’s not. I said no complaining.”</p>
<p>“Yes, sir.” His warm smile, unassuming nature, and honest concern for her had a positive effect.</p>
<p>“Go into the fitting room to try them on.”</p>
<p>He waited patiently until she came out.</p>
<p>“They’re fine, but this is too expensive.” Her long hair always looked good; seemingly nothing could leave it askew.</p>
<p>“Leave that to me. This isn’t too expensive.”</p>
<p>“I have no way to repay you.”</p>
<p>“Anya, you owe me nothing, other than to be happy.”</p>
<p>“Thank you for these clothes.”</p>
<p>“Let’s go upstairs to get some food, so we don’t starve.”</p>
<p>“I can’t…”</p>
<p>“This is my treat.”</p>
<p>“You do too much.”</p>
<p>“I’m happy to do it. It gives me a chance to be with you.” He smiled at her again.</p>
<p>Anya shrugged and glanced away, suddenly shy acting.</p>
<p>They ate and chatted about their courses before getting up to leave. In tiny increments, she was gradually relaxing with him. During their lively chat, Anya clarified, again, Peter’s various “wrong ideas,” to which he objected, but also laughed. Her attempts at a joke encouraged him.</p>
<p>“Let’s go back to your dorm to drop off the bags, and then maybe we can have a study date back at my dorm? You bring some books and then we study together. I’m sure you’ve had enough of going alone to the library.”</p>
<p>“Okay, but I’ve not done this before, this study date.”</p>
<p>“Neither have I.”</p>
<br/><p style="text-align:center;">#</p><br/>
<p>On the walk to Anya’s dorm, it felt different for Peter. The wary edge was gone in Anya, like she finally felt trust enough to let her guard down.</p>
<p>Peter smiled. “Anya, this is nice, being with you.”</p>
<p>“It’s nice being with you also. Thanks again for the gifts.”</p>
<p>It felt good to him to see her smile. “My pleasure. I can’t wait to see you dressed up on Saturday morning.”</p>
<p>It was a pleasant fall day. The prior storm front had moved out of the area to leave a clear azure sky over the sprawling campus. Autumn in the Midwest is idyllic, and this day was another in a long line of pleasant experiences. The great bell tower chimed six times, echoing across campus.</p>
<p>“Anya, I want to say one other thing. Any time you want to call home, I’ll pay for those calls.”</p>
<p>“Peter, they’re very expensive.” She turned her head in amazement.</p>
<p>“It doesn’t matter. These are precious moments and, as you said, she’s your mom.”</p>
<p>Her face suddenly clouded.</p>
<p>“Anya, I didn’t mean to upset you.”</p>
<p>“You’re too kind to me. I feel…” She looked away.</p>
<p>“I can’t imagine being where you are. I’m blessed to have both my parents. I wish I could do more for you.”</p>
<p>“I believe you.”</p>
<p>“I hope you can start to understand I care about you, a lot.”</p>
<p>She turned her head to look at him, but said nothing.</p>
<p>“I really do prefer dark-haired women, with meat on their bones.”</p>
<p>Anya laughed heartily.</p>
<p>“Admittedly, I’m brain-damaged, but I think I grow on you with time.”</p>
<p>“You are a silly man, and you’re still wrong.”</p>
<p>Now it was Peter who laughed heartily. “We’ll just see about that, madam.”</p>
<br/><p style="text-align:center;">#</p><br/>
<p>Arriving at her dorm, Anya went upstairs to drop off the clothes. It took a little time before she came back down. Her facial expression was troubled.</p>
<p>“Did something happen?”</p>
<p>“Megan and her friends questioned me.”</p>
<p>“About…?” His scowl spoke volumes to her about how he felt.</p>
<p>“Because you buy my clothes, they ask if, eh, they think I…it’s not nice.”</p>
<p>Peter bristled. “Why don’t you invite her down for a little chat with me.”</p>
<p>“No, Peter, please. I’m fine. They don’t matter to me.” Her worried expression caught his attention.</p>
<p>“Okay, but I’m not going to let this go on.” He shrugged but still smoldered with ire.</p>
<p>She took his hand to quickly lead him out of her dorm for the walk back to his dorm.</p>
<p>Peter simmered with outrage the entire way. “I can’t believe them. With what you’re facing, to be cruel like that—I can’t believe how people act.”</p>
<p>“It’s okay. It’s over. I’ve dealt with it before. Let me say, you make me feel better about many things.”</p>
<p>He turned his head. “I hope I do. You deserve better treatment from those snarky, smug little bitches.”</p>
<p>“About your offer to call my mother…it means more to me than you could ever know.” With a look of gratefulness, she touched his hand.</p>
<p>“It’s the least I could do. Is it okay if I think of you as my girlfriend? I know we haven’t even had a date yet, but, well, there it is.”</p>
<p>“This is important to you, this having-a-girlfriend thing?”</p>
<p>“Yeah, I felt drawn to you right away, and it keeps growing stronger by the minute.”</p>
<p>“By the minute,” Anya laughed. “That’s amazing, by the minute.”</p>
<p>“Well, I’m just being honest. With me, what you see is what you get.”</p>
<p>“Is that another American adage?”</p>
<p>“It is.”</p>
<p>Arriving at his dorm, they headed for the lounge and claimed a sofa.</p>
<p>“Before I forget, I’d like to invite you here for the Friday-night mixer.”</p>
<p>“What is that?”</p>
<p>“It’s like a dance, a chance for students to mix and mingle. You can meet my roommate.”</p>
<p>“I don’t know American dances.”</p>
<p>“That’s fine. I’ll teach you. What dances do you know?”</p>
<p>“Back in Russia, I didn’t really dance either. It could draw attention on me, in a bad way. There were people there I needed to avoid. I know you don’t understand, being from America. You see things through your experiences. You must simply accept what I’m saying. We didn’t live in a nice area.”</p>
<p>“Thankfully, that’s behind you now.”</p>
<p>She looked away, pondering her life and her mother left behind.</p>
<p>Peter didn’t say anything. He simply started to study.</p>
<p>Anya took out a textbook and started reading. After a moment, he slid over, pressing his body against hers.</p>
<p>“I don’t want for you to get cold,” he whispered.</p>
<p>Shaking her head, she chuckled, “You are…I can’t think of right word.”</p>
<p>“I defy description. That’s why you can’t come up with the word.”</p>
<p>Spending several hours together, Peter felt spiritual closeness with a girl beyond anything in his life up to that point.</p>
<p>Anya smiled at his fumbling attempts at humor. Walking her back to her dorm, on impulse, at the front door, he hugged her. “I’ll see you tomorrow. Sleep well, and dream about me.”</p>
<p>Anya laughed heartily. “You’re still a silly man.”</p>
<p>“I am. No doubt about it.”</p>
<p>For Peter, it was another lively walk back to his dorm. “Life is good,” he muttered cheerily.</p>
<p>When he walked into his room, Bob smirked. “Wow, Peter, you’re beaming. Did you tickle her tonsils?”</p>
<p>“No, you moron. You say the most insane things I’ve ever heard.”</p>
<p>“It’s a gift.”</p>
<p>“Some gift.”</p>
<p>“I have many more.”</p>
<p>“A chilling thought. I shudder to think. By the way, we’re all set with Anya for Friday.”</p>
<p>“Good. I guess I need to come up with some skinny clothes to make me look passable.”</p>
<p>“Somehow, I suspect that’s a sight the world isn’t ready for. I hope you’re not planning on something weird.”</p>
<p>“<em>Moi?</em>”</p>
<p>“Uh-oh.”</p>
<p>Highly entertained with himself, Bob laughed, clapping his hands.</p>
<p>“You better not! I’m trying to win over Anya.”</p>
<p>“No worries, bro.”</p>
<p>“We’ll see. I’ve given you fair warning. If you screw up…you’re going down the toilet.”</p>
<p>“Ooh, I’m trembling.”</p>
<p>Peter brandished his fist, making Bob laugh all the more.</p>
<br/><p style="text-align:center;">#</p><br/>
<p>On Friday in class, Anya seemed a little nervous. She fidgeted noticeably.</p>
<p>Peter asked her afterward, “Is something wrong?”</p>
<p>“About tonight, I feel anxious in crowds sometimes.”</p>
<p>“There’s nothing to worry about. You’ll be there with me and Bob. This will be fun.”</p>
<p>“I’ll try, but this is a risk I’d never take back home in Russia. Bad people are in crowds.”</p>
<p>“You’re not in Russia.”</p>
<p>“I know, but you need to understand my feelings. I had a big scare in a crowd. I’ve never forgotten that fright.”</p>
<p>“I’m sorry that happened to you. If you want to talk, I’m all ears.”</p>
<p>“I’m just saying, I don’t like to draw attention.”</p>
<p>“I know. You’ve told me that already. I’ll take care of you.” He smiled and patted her shoulder.</p>
<p>“I know this seems silly to you.”</p>
<p>“Not really. Your experiences shape your point of view. However, you’re living here, and things aren’t like where you came from. It’s okay to trust.”</p>
<p>“You’re right, it is much different here, but there are still dangers.”</p>
<p>“Are you talking about the mean girls?”</p>
<p>“That’s one of them. I understand if they don’t like me, but why can’t they just leave me alone?”</p>
<p>“That’s a difficult question. I don’t know what makes some people tick.”</p>
<p>“Some things they do are evil.”</p>
<p>“If you run into any of that bad in the future, the evil you’re talking about, you call me immediately. There’s no reason for you to put up with anything. As I said, I’ll be there for you.”</p>
<p>Her smile warmed Peter.</p>
<p>“Thank you,” she whispered.</p>
<p>“Good. Now, moving right along, are you looking forward to this weekend?”</p>
<p>“Possibly.”</p>
<p>Peter chuckled. “You don’t want to concede anything. Is that your plan, to provoke me into acting like a love-starved puppy?”</p>
<p>“No.” She snickered.</p>
<p>“You’re sneaky smart, ma’am. I know what you’re doing, and I’ve got my eye on you.”</p>
<p>She laughed.</p>
<p>“At any rate, after dinner tonight, I’ll walk to your dorm to get you, and then we can walk back here. We can talk with Bob down in the lounge until the party starts, okay?”</p>
<p>“Okay.”</p>
<br/><p style="text-align:center;">#</p><br/>
<p>When Peter went to her dorm later, Anya came down to the lobby, but she was accompanied by Megan. It was clear, from watching Anya’s unease, that this wasn’t her choice.</p>
<p>Megan was exactly what he’d imagined: a girl who would fit in with Allison’s crowd, the bevy of smug beauties. Her sneer irked him, although that sneer transformed into surprise when she saw him.</p>
<p>“You’re Peter?”</p>
<p>“I am.”</p>
<p>“You’re with Anya now?”</p>
<p>“You’d have to ask Anya, but from my perspective we are. Did you have a point to make?”</p>
<p>“There are American girls all over this campus, a lot of us.”</p>
<p>“I choose Anya.”</p>
<p>Megan shrugged her shoulders. “Whatever. That’s your loss.”</p>
<p>Peter was about to lash out at her snarky remark, but Anya took him by the arm, eyeing him in alarm, before he could speak. Megan had already turned and walked away, having successfully cast her aspersion.</p>
<p>“Peter, please don’t. I have trouble enough.”</p>
<p>“I see what you mean. What a bitch. You realize you can change rooms and get a different roommate.”</p>
<p>“I have no guarantee it would be an improvement. The next girl might hate Russians too.”</p>
<p>“I’ll think about that. This is a solvable problem, honey.”</p>
<p>“Honey?”</p>
<p>“It’s a term of endearment. You’re dear to me now.”</p>
<p>“I see.” His remark didn’t fully land, as she was lost in her thoughts.</p>
<p>“By the way, you look really nice.”</p>
<p>“You look nice too.” Still distracted, she answered like a reflex.</p>
<p>“One other thing, Anya; how she said that about American girls, that is her flaw, not yours. She can’t arbitrarily exclude you from the other coeds on this campus because you have an accent.”</p>
<p>“I know what you say, but she has the power, do you see?”</p>
<p>“I don’t buy it. I really think we need to look into moving you out of her room. Probably you should relocate to my dorm.”</p>
<p>“Maybe.”</p>
<p>“You could crash with Bob and me.”</p>
<p>Anya laughed. “You’re talking foolish.”</p>
<p>“Seriously, we can get you on the girls’ side and find a nice girl to be a friend.”</p>
<p>“Okay.”</p>
<p>“There’s no reason to put up with that crap from Megan any longer.”</p>
<p>“I don’t know how to do that.”</p>
<p>“I’ll talk to people at the dorm here to find out the process.”</p>
<p>“Thank you.”</p>
<p>“So, tonight we party, and tomorrow we’ve got the game. Believe me, it will be an awesome experience. Our football team is really good.” He took her hand as they walked. His warm inner glow resumed. “Also, I’m going to learn some Russian.”</p>
<p>“Are you?” She smirked.</p>
<p>“I am. We’re going to have a conversation in the future.”</p>
<p>“Well in the future.” Anya laughed heartily.</p>
<p>“Real funny, Anya. You’re a real comedian. You might be surprised at what I can do. I am capable of learning things.”</p>
<p>“I think you rub off on me.”</p>
<p>“Well, then you’re in big trouble. By the way, we can go shopping on Sunday to buy a few more clothes for you. I know your wardrobe is limited. I want to help. We can chip away a little at a time.”</p>
<p>“I feel badly. I know you mean well, but you do too much for me.”</p>
<p>“I don’t see it that way. Maybe I didn’t explain it clearly enough. If I couldn’t afford it, that would be one thing, but, as I explained, my family is flush. I mean, they are really set, and I have more money available than I can spend, so why not?”</p>
<p>She glanced at him.</p>
<p>He spoke before she could answer: “Okay, so it’s settled: we shop on Sunday.”</p>
<p>“I didn’t agree.”</p>
<p>“You did, without realizing it. The matter is settled. It’s time to start helping you be part of the <em>bourgeoisie</em>.”</p>
<p>“I’m not Communist.”</p>
<p>“That was a joke, honey. I warned you about my low level of humor. <em>Мы вас похороним.”</em></p>
<p>Anya laughed. “We will bury you? Where did you learn that?”</p>
<p>“I looked it up on the Internet: that old Khrushchev speech from the sixties.”</p>
<p>“I think maybe you were dropped on your head as a baby.”</p>
<p>“That’s a strong possibility.”</p>
<p>“Oh my, maybe I teach you some Russian. You’re not doing so well on your own.”</p>
<p>“I’m in.”</p>
<p>Her gentle squeeze of his hand was gratifying nonverbal communication that spoke volumes, just like her warm smile.</p>
<p>“We will bury you.” She snickered again, shaking her head in amusement. “That’s idiotic. What have I done?”</p>
<p>“You’ve decided to join the American peoples, of which I’m the prime representative. I will teach you everything you need to know.”</p>
<p>“I see.”</p>
<p>Arriving at the dorm, Peter led Anya up the stairs to go to his room. Bob was waiting excitedly. He sprang out of his chair.</p>
<p>“Bob, this is Anya.”</p>
<p>“Hi, Anya, it’s nice to meet you.”</p>
<p>“Hello, Bob.”</p>
<p>“You look really pretty.”</p>
<p>She blushed, glancing shyly at Peter. “Thank you.”</p>
<p>Suddenly Bob stepped over to embrace her, firmly. In an extended hug, she got a look of alarm.</p>
<p>Peter spoke. “Okay, Bob, she’s already got a date tonight.”</p>
<p>Bob laughed. “So, are you ready to cut some rug?”</p>
<p>Anya eyed him in confusion. “What?”</p>
<p>Peter chuckled. “It’s slang for dancing.”</p>
<p>“Oh. I don’t know American dances.”</p>
<p>“We’ll teach you, honey.”</p>
<p>Bob added. “Let’s go. We can get a table before the room fills up.”</p>
<p>They made their way down the stairs, up the hallway into the grill, where there was already considerable student traffic. Peter sat down at a table with Anya, while Bob went to order colas.</p>
<p>Anya looked around nervously.</p>
<p>“Don’t worry. These people aren’t a threat to you. They’re just other students looking to have a good time.”</p>
<p>She didn’t reply. Her mind whirred with her past, and those terrifying emotions, and it showed in her facial expressions.</p>
<p>Bob came back with three drinks. With a young man sitting on each side of her, this seemed to calm Anya only slightly. The increasing noise level of more students arriving affected her. She glanced around frequently, almost furtively.</p>
<p>Conversing turned into shouting to be heard.</p>
<p>Bob touched Anya’s arm to get her attention. “So, do you like America?”</p>
<p>“There are some things I like.”</p>
<p>“What don’t you like?”</p>
<p>“Being an eternal foreigner, I feel I must be guarded always. After time, it gets burdensome.”</p>
<p>“I’m sorry. I didn’t think of it that way. Saying the right thing is one of my opportunity areas.”</p>
<p>At that moment, Allison arrived with her entourage. She looked directly at Peter and then at Anya. Peter looked at Anya, feeling instantly protective of her. To their chagrin, Allison came over.</p>
<p>“Peter, what a nice surprise to see you; and out socially. Who is this?”</p>
<p>“This is Anya, my girlfriend.”</p>
<p>“Girlfriend? Really.”</p>
<p>“Yes, ma’am.”</p>
<p>“Hello, Anya.” Coolly, Allison eyed her up and down with a calculating glance. Anya didn’t sense friendship in her visit.</p>
<p>“Hello,” she answered in a low voice.</p>
<p>“How did you meet Peter?” Her tone was pointed, a little too sharp.</p>
<p>He answered. “We have class together.”</p>
<p>At that moment, the music started, along with the dancing.</p>
<p>“Do you mind if I dance with your boyfriend?” Allison didn’t wait for a reply. She grabbed a reluctant Peter by the hand and dragged him bodily out into the middle of the swirling bodies.</p>
<p>Allison was particularly sensual in how she danced, violating his personal space frequently, swaying and swirling in rhythm with the music. Bumping against him often, it was just the encounter he would have prayed for not so long ago. However, this was the time of Anya, and seeing the discomfort on her face while watching Allison rubbing her nose in it, Peter nearly walked off the floor.</p>
<p>Once the song ended, Allison grabbed his hand before he could leave. “We’ve known each other a long time, Peter. What’s with hooking up with her?”</p>
<p>“Hooking up? Anya and I have just met, and are very early in a relationship. I like her because she’s a nice person.”</p>
<p>“And I’m not?”</p>
<p>He eyed her, curious. “Allison, what are you saying? You and I have never been together.”</p>
<p>“Is that my fault? You were always so passive. Do you think I liked that?”</p>
<p>“I never thought about it. Of course, you know I liked you, but you had your options, elsewhere.”</p>
<p>“I’m a social person. There’s nothing wrong with having a lot of friends.”</p>
<p>“I don’t know what you want. I’m here tonight with Anya.”</p>
<p>“That’s your choice. Perhaps you have options, too. Did you ever think of that?”</p>
<p>Turning and walking away, she stirred him up, but toward confusion. Although provoked, his focus remained with Anya. Sitting back down at the table, he scooted his chair close to her.</p>
<p>“I’m sorry, honey. I have no idea what that was about.”</p>
<p>“She likes you. That’s easy to see.” She eyed him with a neutral expression.</p>
<p>“I knew her from high school, but we didn’t date.”</p>
<p>“I think she would like to date.”</p>
<p>“I doubt that. I think she was just twisting my tail. I’m not sure why, though. Women are mystifying creatures that can’t be understood.”</p>
<p>Bob spoke. “Do you want for me to take her off your hands?” He laughed hysterically.</p>
<p>“I’d appreciate it, but even if it was doable, I’d warn you to give her a wide berth. I don’t think I could ever trust her. She’s more the type to leave a trail littered with the bodies of her romantic discards.”</p>
<p>“She is like my roommate.”</p>
<p>“You might be right, Anya. So, do you want to try our first dance?”</p>
<p>“No, but you’ll make me do it.” She paused and took a deep breath before she stood up.</p>
<p>They rose and went to the edge of the dancers, Peter leading her by the hand. Anya was tentative, mimicking Peter’s steps. Starting to gain a little confidence, she duplicated the moves of the other girls around her and relaxed into the dancing. Even with her first dance, she was better than passable; she was decent.</p>
<p>Peter noticed Allison not far away, dancing with a stud, but she was watching Anya. Her expression was less than friendly, eyeing her grimly.</p>
<p>Again, Peter felt protective of his new “girlfriend.” Taking her into an embrace as they danced, he eyed Allison harshly. She smirked in return, like Peter had fallen for a ploy. Anya was focused on mastering the dance and missed the entire exchange.</p>
<p>Staying on the floor for the start of the next song with Anya, to his shock, they were joined by Bob, with an actual girl.</p>
<p>“Hey, Bob,” he spoke with surprise, but in a pleasant way.</p>
<p>“This is Christy. She agreed to allow me to trample her toes.”</p>
<p>The four of them laughed. Peter bumped fists with Bob. Anya smiled at Christy.</p>
<p>When the music started, Bob proved to be a better dancer than Peter would have thought. Christy seemed to enjoy being with him. Not only did they dance together but she chatted the whole time.</p>
<p>They stayed through a succession of tunes before finally sitting back down at the table for a breather.</p>
<p>“Hi, I’m Christy.” She smiled at Anya. Christy had a lively manner. She came across as genuinely friendly and fun to be with.</p>
<p>“I’m Anya.”</p>
<p>“What’s your major, Christy?” Peter asked.</p>
<p>“Marketing. I’ve got a big mouth, so I figured it’s the right choice for me. I’m not Miss America, so I’ve got to use what assets I have.”</p>
<p>“You look fine to me,” Bob said. “I’m not Mr. America.”</p>
<p>“How are things with your roommate?” Peter continued.</p>
<p>“My roommate? Why do you ask?”</p>
<p>“I’m looking for someone as an option for Anya, my girlfriend. She drew a short straw over at her dorm. I want her out of that hostile environment as soon as possible.”</p>
<p>“Oh. Eh, I can certainly inquire. I’m not sure if it could be done mid-semester, but I’ll ask. What do you say, Anya? Could you live with me?”</p>
<p>Anya smiled. “I think it’s more if you could live with me. I’m the foreigner.”</p>
<p>“Foreigner has nothing to do with it. I gather it’s pretty bad over there at your dorm?”</p>
<p>Peter answered. “You have no idea.”</p>
<p>To break a momentary awkward silence, Peter continued.</p>
<p>“Listen, we’re going to the game tomorrow. Will you join us?”</p>
<p>“My ticket isn’t beside you.”</p>
<p>“We can trade around to get four together. I’ll handle it. Don’t worry about that.”</p>
<p>She looked at Bob, who replied, “Is that okay…hanging out with me, Christy?”</p>
<p>“Sure, why not?”</p>
<p>“I’m sorry to put all of this on you. I know we’re strangers, but we’re good people.” Peter added.</p>
<p>Bob smiled hopefully.</p>
<p>“That’s okay, Peter. If I can help out, I’m happy to do it. My roommate and I aren’t particularly close. I can certainly live with Anya.”</p>
<p>The music resumed, along with their dancing. Smiling, Anya looked to be enjoying herself. Peter was happy to have Anya violating his personal space, following Allison’s lead with how to dance. From her first dance to her final one, it was remarkable to him not only the transformation in her grasp of the moment, but also the blossoming of her spirit. Her dancing was very good at the end, comparable to the girls around her.</p>
<p>Afterward, Peter walked her out of the event with an arm around her waist.</p>
<p>“I told you this would be fun.”</p>
<p>“I’m surprised. It isn’t something I would seek to do. I concede that for once, you weren’t wrong.”</p>
<p>“Oh, come on, Anya. Give me a break with the ‘wrong’ thing.”</p>
<p>They both chuckled, and she put her arm around his waist. As they walked into the night air, it was cool after leaving the hot dance floor. The clear sky shimmered with the Milky Way arrayed in splendor over their heads.</p>
<p>“It’s so peaceful,” she whispered. “I like this very much.”</p>
<p>“Don’t forget, tomorrow it’s a noon start for the game, and Sunday we shop for clothes.”</p>
<p>“Peter…”</p>
<p>“Don’t even say it. The matter is closed. Maybe after we get back to your dorm, we’ll call your mother?”</p>
<p>“There is time difference. Day here is night there.”</p>
<p>“Well, tomorrow night then. I’ll stay up with you if you’d like. I’ve got a phone card with plenty of credit.”</p>
<p>“She will be surprised to hear from me.”</p>
<p>“I’ve got some other ideas, but I’ll tell you later. First, I’ve got to figure some things out.”</p>
<p>Suddenly stopping him, turning her body, Anya put her hands to his face for their first kiss, gentle and soft. It was immensely provocative for Peter.</p>
<p>“Wow, that was nice, Anya.”</p>
<p>“I like you, Peter. I want you to know that.”</p>
<p>“Thank you, darling. I was hoping you would come around. I didn’t want you to feel beholden.”</p>
<p>They continued their gradual stroll. Neither of them was anxious for the evening to end.</p>
<p>At the door of her dorm, they kissed again, this time with more passion. Peter was in awe; grateful she hadn’t rejected him.</p>
<p>“Was my kiss okay? I really want to be sure I don’t screw up with you.”</p>
<p>She chuckled. “Peter, you’re fine. You don’t need to worry about silly things.”</p>
<p>“I guess I’ll see you tomorrow in the new clothes.”</p>
<p>“You will. I look forward to it.”</p>
<p>“I’ll get with Christy about changing rooms to see what she finds out.”</p>
<p>“Thank you.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?e02d1e30